export default "__VITE_ASSET__BnbVVkSu__"